import React from 'react';
import Dashboard from './pages/Dashboard';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Signup from './components/Auth/Signup';
import Login from './components/Auth/Login';
import AddProduct from './components/Product/AddProduct';
import ViewMyProduct  from './components/Product/ViewMyProduct';
import ShippingOrders  from './components/Orders/ShippingOrders';
import OverviewOrders  from './components/Orders/OverviewOrders';
import ViewConfirmedOrders from './components/Orders/ViewConfirmedOrders';
import ManageTransaction from './components/Transaction/ManageTransaction';
import Profile from './pages/Profile';
import TransactionDetails from './components/Transaction/TransactionDetails';
function App() {
  return (
    <>
      <Router>
        <Switch>
          <Route path="/profile" component={Profile} />
          <Route path="/signup" component={Signup} />
          <Route path="/login" component={Login} />
          <Route path="/add-product" component={AddProduct} />
          <Route path="/view-my-product" component={ViewMyProduct} />
          <Route path="/view-confirmed-orders" component={ViewConfirmedOrders} />
          <Route path="/shipping-orders" component={ShippingOrders} />
          <Route path="/overview-orders" component={OverviewOrders} />
          <Route path="/manage-transaction" component={ManageTransaction} />
          <Route path="/transaction/id" component={TransactionDetails}/>
          <Route path="/" component={Dashboard} />
        </Switch>
      </Router>
    </>
  );
}
export default App;